import { useEffect, useState } from "react";
import axios from "axios";
import categoriasConEmoji from "../utils/categoriasConEmoji";

import Layout from "../layout/Layout";
const categorias = [
    "Todos",
    "Comida",
    "Renta",
    "Gas",
    "Luz",
    "Agua",
    "Mantenimiento",
    "Plataformas",
    "Transporte",
    "Otros"
];

export default function Historial() {
    const [gastos, setGastos] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [editGasto, setEditGasto] = useState({});
    const [mes, setMes] = useState("");
    const [categoria, setCategoria] = useState("Todos");

    const cargarGastos = async () => {
        try {
            const params = new URLSearchParams();
            if (mes) params.append("mes", mes);
            if (categoria && categoria !== "Todos") params.append("categoria", categoria);

            const res = await axios.get(
                `${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/gastos/list?${params.toString()}`,
                { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
            );

            if (res.data.success) {
                setGastos(res.data.data);
            } else {
                alert("Error al obtener gastos");
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        cargarGastos();
    }, [mes, categoria]);

    const handleDelete = async (id) => {
        const confirm = window.confirm("¿Estás segura de eliminar este gasto?");
        if (!confirm) return;

        try {
            const res = await axios.post(`${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/gastos/delete`, { id }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            });

            if (res.data.success) {
                setGastos(gastos.filter(g => g.id !== id));
            } else {
                alert("No se pudo eliminar");
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleEdit = (index) => {
        setEditIndex(index);
        setEditGasto(gastos[index]);
    };

    const handleUpdate = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/gastos/update`, editGasto, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            });

            if (res.data.success) {
                const nuevos = [...gastos];
                nuevos[editIndex] = editGasto;
                setGastos(nuevos);
                setEditIndex(null);
            } else {
                alert("No se pudo actualizar");
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Layout>
            <div className="container text-center">
                <div className="row">
                    <div className="col">

                            <h2>Historial de Gastos</h2>

                            <div className="d-flex">
                                <div className="flex-1">
                                <label>Filtrar por mes: </label>
                                <input className="form-control" type="month" value={mes} onChange={(e) => setMes(e.target.value)} />
                                

                                </div>
                                <div className="flex-1">
                                <label>Categoría: </label>
                                <select  className="form-control" value={categoria} onChange={(e) => setCategoria(e.target.value)}>
                                    {categorias.map((cat) => (
                                        <option key={cat} value={cat}>
                                            {categoriasConEmoji[cat] || ""} {cat}
                                        </option>
                                    ))}
                                </select>

                                </div>
                            </div>


                {gastos.length === 0 ? (
                    <p>No hay gastos en este filtro</p>
                ) : (
                    <table className="table table-striped text-start">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Monto</th>
                                <th>Categoría</th>
                                <th>Fecha</th>
                                <th>Quincena</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gastos.map((gasto, i) => (
                                <tr key={gasto.id}>
                                    <td>
                                        {editIndex === i ? (
                                            <input
                                                value={editGasto.nombre}
                                                onChange={(e) => setEditGasto({ ...editGasto, nombre: e.target.value })}
                                            />
                                        ) : (
                                            gasto.nombre
                                        )}
                                    </td>
                                    <td>
                                        {editIndex === i ? (
                                            <input
                                                type="number"
                                                value={editGasto.monto}
                                                onChange={(e) => setEditGasto({ ...editGasto, monto: e.target.value })}
                                            />
                                        ) : (
                                            `$${gasto.monto}`
                                        )}
                                    </td>
                                    <td>{categoriasConEmoji[gasto.categoria] || ""} {gasto.categoria}</td>
                                    <td>{gasto.fecha}</td>
                                    <td>Q{gasto.quincena}</td>
                                    <td>
                                        {editIndex === i ? (
                                            <>
                                                <button className="btn btn-warning" onClick={handleUpdate}>Guardar</button>
                                                <button className="btn btn-danger" onClick={() => setEditIndex(null)}>Cancelar</button>
                                            </>
                                        ) : (
                                            <>
                                                <button className="btn btn-success" onClick={() => handleEdit(i)}>Editar</button>
                                                <button className="btn btn-danger" onClick={() => handleDelete(gasto.id)}>Eliminar</button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                    </div>
                </div>
            </div>
        </Layout>
    );
}
